export const iconFontAwesomeTransportationCarTunnel = (
	<i className="fa-solid fa-car-tunnel"></i>
);
